// extracted by mini-css-extract-plugin
export default {"linkPreDocuments":"linkPreDocuments--bhGCw"};